import React, { useEffect, useState } from 'react';
import Column from '@amzn/meridian/column';
import RadioButton from '@amzn/meridian/radio-button';
import Text from '@amzn/meridian/text';
import { FormattedMessage, useIntl } from 'react-intl';
import YesCheck from '../../commons/formLibrary/YesCheck';
import NoX from '../../commons/formLibrary/NoX';
import { RadioButtonType } from './formData.types';
import { grabSectionByID, grabRadioOptionsByID } from './helpers';
import {
  CAPAnsweredQuestionItem,
  CAPBulletPointItem,
  DropdownItem,
  Question,
} from './formData.types';

type RadioButtonValueType = React.ComponentProps<typeof RadioButton>['value'];

interface RadioButtonOption extends React.ComponentProps<typeof RadioButton> {
  label: string;
}

interface RenderGenericRadioButtonsFromDataProps
  extends React.ComponentProps<typeof RadioButton> {
  selected: CAPAnsweredQuestionItem | undefined;
  question: Question;
  styles: any;
  onChange: (args: CAPAnsweredQuestionItem) => void;
  metBar: boolean;
}

const RenderGenericRadioButtonsFromData: React.FC<
  RenderGenericRadioButtonsFromDataProps
> = ({
  ...props
}: RenderGenericRadioButtonsFromDataProps): React.ReactElement => {
  return (
    <div>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <GenericBasicRadioButtonsFromData {...props} />
    </div>
  );
};

const GenericBasicRadioButtonsFromData: React.FC<
  RenderGenericRadioButtonsFromDataProps
> = ({
  question,
  selected,
  onChange,
  disabled,
  styles,
  metBar,
  ...props
}: RenderGenericRadioButtonsFromDataProps): React.ReactElement => {
  const handleChange = (value: any) => {
    onChange({
      checkedValue: value.toString(),
      numValue: value,
    });
  };

  const intl = useIntl();

  return (
    <Column
      spacingInset='small none'
      spacing='small'
      className={styles.genericRightStepperItem}
    >
      <Text>
        {intl.formatMessage({
          id: question.QUESTION_TEXT.TRANSLATION_ID,
          defaultMessage: question.QUESTION_TEXT.DEFAULT_MESSAGE,
        })}
      </Text>
      {question?.QUESTION_OPTIONS?.map(option => (
        <RadioButton
          value={option.VALUE}
          key={`${option.CATEGORY}_value_${option.VALUE}`}
          onChange={() => handleChange(option.VALUE)}
          checked={option.VALUE === selected?.numValue}
        >
          {metBar ? (
            option.VALUE === 1 ? (
              <>
                <YesCheck
                  tooltip='Meets the bar'
                  className={styles.yesCheckGreen}
                />
                <span className={styles.iconDescriptor}></span>
                <FormattedMessage
                  id={option.TRANSLATION_ID}
                  defaultMessage={option.DEFAULT_MESSAGE}
                />
              </>
            ) : option.VALUE === 0 ? (
              <>
                <NoX
                  tooltip='Does not meet the bar'
                  className={styles.noXRed}
                />
                <span className={styles.iconDescriptor}></span>
                <FormattedMessage
                  id={option.TRANSLATION_ID}
                  defaultMessage={option.DEFAULT_MESSAGE}
                />
              </>
            ) : (
              <FormattedMessage
                id={option.TRANSLATION_ID}
                defaultMessage={option.DEFAULT_MESSAGE}
              />
            )
          ) : (
            <FormattedMessage
              id={option.TRANSLATION_ID}
              defaultMessage={option.DEFAULT_MESSAGE}
            />
          )}
        </RadioButton>
      ))}
    </Column>
  );
};

export default RenderGenericRadioButtonsFromData;
